import React, { useEffect, useCallback, useState} from 'react';
import Edge from './Edge.js';
import {connect} from 'react-redux';

const EffectEdges = ({fromWindow, outputPrefix, scale, containerRef, fromId, type, fx, pad, id}) => { 
    let rack = pad.effectRack;
    let adj = rack.adjacencyLists;
    let edges = adj[id || fx.id];
    if (!edges) {
        return [];
    }
    let _style = {
    };
    if (scale !== 1) {
        _style.transform = 'scale(' + (1/scale) + ')';
    }
    return edges.map(
        (edge, i) => 
            <Edge
              key={edge.effect.id}
              containerRef={containerRef}
              fromWindow={fromWindow}
              outputPrefix={outputPrefix}
              scale={scale}
              fromId={fromId || fx.id}
              pad={pad}
              edge={edge}
              fx={fx}/>);
};

const mapStateToProps = (state, props) => {
    let adj = props.pad.effectRack.adjacencyLists[props.ffrom || props.fx.id];
    return {
        selectedEdge: state.pads.selectedEdge,
        numEdges: adj && adj.length,
        effects: state.pads.padEffects[props.pad.id],
        midiEffects: state.pads.trackMidiEffects[props.pad.id],
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectEdges);
